import React from 'react';
import styled from 'styled-components';
import { CONTACT_EMAIL } from '../constants/gaming';

const AboutContainer = styled.div`
  max-width: 900px;
  margin: 40px auto;
  padding: 0 20px;
  color: #e0e0e0;

  h1 {
    font-size: 2.5rem;
    color: var(--light);
    margin-bottom: 16px;
    text-align: center;
  }

  .subtitle {
    font-size: 1.3rem;
    color: var(--primary);
    text-align: center;
    margin-bottom: 40px;
  }

  section {
    margin-bottom: 48px;

    h2 {
      font-size: 1.8rem;
      color: var(--light);
      margin-bottom: 20px;
      border-bottom: 2px solid var(--primary);
      padding-bottom: 8px;
    }

    p {
      font-size: 1.1rem;
      line-height: 1.7;
      margin-bottom: 16px;
      color: #bdbdbd;
    }

    ul {
      list-style: none;
      padding: 0;

      li {
        font-size: 1.05rem;
        margin: 12px 0;
        padding-left: 24px;
        position: relative;

        &::before {
          content: '→';
          position: absolute;
          left: 0;
          color: var(--primary);
        }
      }
    }

    .stats {
      display: flex;
      flex-wrap: wrap;
      gap: 24px;
      justify-content: center;
      margin: 32px 0;

      .stat {
        background: var(--card-bg);
        padding: 20px 32px;
        border-radius: 12px;
        text-align: center;
        min-width: 160px;
        box-shadow: 0 4px 12px rgba(0,0,0,0.3);

        .number {
          font-size: 2.2rem;
          font-weight: bold;
          color: var(--primary);
          display: block;
        }

        .label {
          font-size: 1rem;
          color: #bdbdbd;
        }
      }
    }
  }

  .cta {
    text-align: center;
    margin-top: 60px;

    a {
      display: inline-block;
      background: var(--primary);
      color: var(--dark);
      padding: 14px 32px;
      border-radius: 50px;
      font-weight: bold;
      text-decoration: none;
      transition: all 0.3s ease;

      &:hover {
        transform: translateY(-3px);
        box-shadow: 0 8px 20px rgba(var(--primary-rgb), 0.4);
      }
    }
  }

  @media (max-width: 768px) {
    h1 { font-size: 2rem; }
    .subtitle { font-size: 1.1rem; }
    section h2 { font-size: 1.6rem; }
  }
`;

const About = () => {
  return (
    <AboutContainer>
      <h1>About ModMedia Network™</h1>
      <div className="subtitle">Full-Stack WEBDEVs | Independent Journalists | Deep-Tech Community Builders</div>

      <section>
        <h2>Who We Are:</h2>
        <p>Akihiko- a Full-Stack Web Developer with over four years of hands-on experience designing, building, and deploying scalable web and blockchain-based applications.</p>
        <p>Mike Reyes- an Entrepreneurial CEO, Digital Nomad, Political Finance Writer and Web3/Crypto Advocate. Mike's articles harbor insights that will- speculatively, in theory- Make You Rich. (Not Financial Advice)</p>
        <p>Charles Sprain- a Systems Admin by Nature, Charles strives to deliver quality in everything we publish and produce. He is ModMedia Network's Founder, Lead Editor/Analyst, and Cybersecure Crypto Operator.</p>
      </section>

      <section>
        <h2>Shared Technical Excellence</h2>
        <ul>
          <li><strong>Frontend:</strong> React, TypeScript, Tailwind CSS, Framer Motion, styled-components</li>
          <li><strong>Backend:</strong> Node.js, Express, AWS, Supabase, MongoDB, PostgreSQL</li>
          <li><strong>Blockchain & Web3:</strong> Solidity, Web3.js, Ethers.js, Hardhat, IPFS, The Graph</li>
          <li><strong>DevOps & Tools:</strong> Git, Docker, Vercel, AWS Lambda, CI/CD pipelines, REST & GraphQL APIs</li>
          <li><strong>Crypto:</strong> Proof-of-Work, Funamental and Technical Analysis, Legislative Breakdowns and Commentary </li>
          <li><strong>Cybersecurity:</strong> Offline Finance Practices, Hardware-Signing Data/Transactions, Exposing & Reporting Online Scams </li>
        </ul>
      </section>

      <section>
        <h2>Our Projects and Clients</h2>
        <p>Cumulatively, our team has (individually or together) delivered 300+ projects with high client satisfaction, ranging from Web3 platforms to community tools, brand websites, and even past construction engineering sector work.</p>
          <p>We combine technical excellence with strong community leadership, having managed and grown multiple Web3 ecosystems over the past years — developing and establishing communities of 10,000+ users altogether.</p>
        <ul>
          <li><strong>ModMedia Labs Website</strong> — Led end-to-end development with cutting-edge Web3 integration (Feb 2025 – Jul 2025, USA remote)</li>
          <li><strong>Krypto Miners Club Website & TRADE X Bot</strong> — Full design, development, and deployment; strategic trading/investment optimization (Jul 2022 – Dec 2022, Dubai remote)</li>
          <li><strong>MineAI Community Platform</strong> — Built engagement & analytics dashboard for 15K+ members (Nov 2022 – Jan 2025, Dubai remote)</li>
          <li><strong>Blockguard Network</strong> — Contributed to DeFi protocol focused on security & compliance</li>
          <li><strong>Montana City Estate Website</strong> — Contract development from client concept to live site</li>
          <li><strong>And Even More</strong> — Check our <a href="https://bio.site/modmedia">ModMedia Designed Websites Portfolio</a> to see our latest Web Portfolio</li>
        </ul>
      </section>

      <section>
        <h2>Impact & Stats</h2>
        <div className="stats">
          <div className="stat">
            <span className="number">25+ Years</span>
            <span className="label">Team Professional Experience Cumulative Total</span>
          </div>
          <div className="stat">
            <span className="number">300+</span>
            <span className="label">Lifetime Team-Member Projects, Various Sectors</span>
          </div>
          <div className="stat">
            <span className="number">10K+</span>
            <span className="label">Web3 Users Across our Initiatives</span>
          </div>
          <div className="stat">
            <span className="number">100%</span>
            <span className="label">Client Fulfillment</span>
          </div>
        </div>
      </section>

      <div className="cta">
        <a href={`mailto:${CONTACT_EMAIL}`}>Contact Us →</a>
      </div>
    </AboutContainer>
  );
};

export default About;
